var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600.14 350.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#020230;}.cls-4{clip-path:url(#clip-path);}.cls-22,.cls-5,.cls-61{opacity:0.8;}.cls-47,.cls-48,.cls-5,.cls-55,.cls-6{mix-blend-mode:lighten;}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144);}.cls-7{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-2);}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-3);}.cls-9{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-4);}.cls-10{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-5);}.cls-11{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-6);}.cls-12{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-7);}.cls-13{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-8);}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-9);}.cls-15{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-10);}.cls-16{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-11);}.cls-17{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-12);}.cls-18{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_144-13);}.cls-19,.cls-20,.cls-21{fill:#172f78;}.cls-19,.cls-44{opacity:0.4;}.cls-20,.cls-55,.cls-63{opacity:0.6;}.cls-22{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_50);}.cls-23{fill:#03a7d3;}.cls-24{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_515);}.cls-25{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_19);}.cls-26{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_515-2);}.cls-27,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65{fill:#fff;}.cls-28,.cls-30{opacity:0.5;}.cls-29,.cls-30{fill:#380031;}.cls-31{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_242);}.cls-32{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_249);}.cls-33{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297);}.cls-34{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297-2);}.cls-35{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297-3);}.cls-36{fill:#183372;}.cls-37{fill:#043a76;}.cls-38{fill:#3dc6e3;}.cls-39{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_242-2);}.cls-40{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_266);}.cls-41{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_266-2);}.cls-42{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_260);}.cls-43{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_249-2);}.cls-44{fill:#06033e;}.cls-45{clip-path:url(#clip-path-2);}.cls-46{fill:#c7e6ec;}.cls-47,.cls-48,.cls-64{opacity:0.3;}.cls-47{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_15);}.cls-48{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_15-2);}.cls-49{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_242-3);}.cls-50{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_249-3);}.cls-51{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297-4);}.cls-52{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297-5);}.cls-53{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_297-6);}.cls-54{fill:#11203c;}.cls-55{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_44);}.cls-56{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_354);}.cls-57{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_67);}.cls-58{fill:#fb8488;}.cls-59{fill:#8b1e64;}.cls-60{opacity:0.9;}.cls-62{opacity:0.7;}.cls-65{opacity:0.1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.14,
    y: 0.25,
    width: 600,
    height: 349.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144",
    x1: 1573.35,
    y1: -35.84,
    x2: 1433.74,
    y2: 73.07,
    gradientTransform: "translate(2022.21 350.38) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-2",
    x1: 2085.64,
    y1: 317.02,
    x2: 1878.68,
    y2: 253,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-3",
    x1: 1486.8,
    y1: 69.68,
    x2: 1751.11,
    y2: 69.68,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-4",
    x1: 1410.8,
    y1: 162.87,
    x2: 1635.33,
    y2: 162.87,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-5",
    x1: 1840.01,
    y1: 153.3,
    x2: 1795.12,
    y2: 258.09,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-6",
    x1: 1634.83,
    y1: 172.3,
    x2: 1821.26,
    y2: 172.3,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-7",
    x1: 1453.34,
    y1: 233.31,
    x2: 1717.44,
    y2: 233.31,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-8",
    x1: 1541.34,
    y1: 293.31,
    x2: 1805.44,
    y2: 293.31,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-9",
    x1: 2067.87,
    y1: 156.85,
    x2: 1913.89,
    y2: 41.97,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-10",
    x1: 1636.1,
    y1: 44.76,
    x2: 1801.02,
    y2: 44.76,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-11",
    x1: 2007.72,
    y1: -47.38,
    x2: 1836.07,
    y2: 50.92,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-12",
    x1: 1348.07,
    y1: 219.69,
    x2: 1509.44,
    y2: 219.69,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144-13",
    x1: 1422.56,
    y1: 390.35,
    x2: 1527.95,
    y2: 268.15,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_50",
    x1: 300.14,
    y1: 350.19,
    x2: 300.14,
    y2: 0.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#030534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#070d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0d1b55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_515",
    x1: -364.19,
    y1: 122.48,
    x2: -204.86,
    y2: 122.48,
    gradientTransform: "translate(522.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6246e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9636b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_19",
    x1: -332.93,
    y1: 201,
    x2: -243.45,
    y2: 201,
    gradientTransform: "translate(522.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9636b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#b7256e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6246e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_515-2",
    x1: -231.66,
    y1: 191.2,
    x2: -402.14,
    y2: 200.31,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_515"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_242",
    cx: 581.61,
    cy: 134.97,
    r: 182.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#03bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#08a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#107bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1177b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_249",
    x1: 349.84,
    y1: 33.06,
    x2: 462.89,
    y2: 55.14,
    gradientTransform: "matrix(0.87, 0.5, 0, 1, 35.23, -131.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#03bee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#08a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#107bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1177b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172f78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297",
    x1: 349.09,
    y1: 39.42,
    x2: 502.83,
    y2: 69.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#02c5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#04bbe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#07abdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0b94cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1177b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172f78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297-2",
    x1: 357.96,
    y1: 46.07,
    x2: 358,
    y2: 46.08,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297-3",
    x1: 357.96,
    y1: 44.76,
    x2: 358,
    y2: 44.77,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_242-2",
    cx: 409.01,
    cy: 146.77,
    r: 66.1,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_242"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_266",
    cx: 207.24,
    cy: -379.25,
    r: 36.12,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, 163.86, 639.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#04a9d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0a71a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0e4881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#102e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112564"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_266-2",
    cx: 374.86,
    cy: 65.76,
    r: 82.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_266"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_260",
    x1: 339.71,
    y1: 123.82,
    x2: 409.82,
    y2: 144.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#01c6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#02bfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#04b4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#06a3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0a8dc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0d71ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#125293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#172f78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_249-2",
    x1: 343.64,
    y1: 132.56,
    x2: 411.49,
    y2: 132.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_249"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.64,103.73l-16.19,9.35,40.31,23.27a2.42,2.42,0,0,1,.55.46l16.17-9.38a2.71,2.71,0,0,0-.92-.65Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_15",
    cx: 475.31,
    cy: 76.92,
    r: 75.67,
    gradientTransform: "translate(193.6 -313.56) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#01a4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0179a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#02547f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#023663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#021f4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#020f3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#020533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020230"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_15-2",
    cx: 357.97,
    cy: 76.92,
    r: 75.67,
    gradientTransform: "translate(159.24 -230.6) rotate(45)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_242-3",
    cx: 694.75,
    cy: 135.09,
    r: 181.47,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_242"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_249-3",
    x1: 482.69,
    y1: -32.78,
    x2: 594.86,
    y2: -10.87,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297-4",
    x1: 464.06,
    y1: 40.3,
    x2: 616.59,
    y2: 70.09,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297-5",
    x1: 472.86,
    y1: 46.9,
    x2: 472.89,
    y2: 46.9,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297-6",
    x1: 472.86,
    y1: 45.6,
    x2: 472.89,
    y2: 45.61,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_297"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_44",
    cx: 452.3,
    cy: 250.37,
    r: 72.36,
    gradientTransform: "translate(595.59 -246.35) rotate(77.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8359e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e63192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#aa246c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#76194b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4b1030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2b091b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#13040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_354",
    x1: 385.98,
    y1: 273.18,
    x2: 473.36,
    y2: 273.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04b1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0e6ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#154085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172f78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_67",
    cx: 389.97,
    cy: 247.58,
    r: 141.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9636b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6246e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.14,
    y: 0.19,
    width: 600,
    height: 350
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "600.14 350.13 600.14 221.47 390.11 350.13 600.14 350.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "124.45 211.27 216.77 0.25 0.14 0.25 0.14 138.02 124.45 211.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "360.1 350.13 390.11 350.13 535.41 261.12 124.45 211.27 360.1 350.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "535.41 261.12 480.87 113.9 310.88 233.88 535.41 261.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "265.92 122.26 216.77 0.25 124.45 211.27 265.92 122.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "310.88 233.88 265.92 122.26 124.45 211.27 310.88 233.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "310.88 233.88 480.87 113.9 216.77 0.25 310.88 233.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "480.87 113.9 438.77 0.25 216.77 0.25 480.87 113.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "209.05 261.12 0.14 138.02 0.14 350.13 209.05 261.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "360.1 350.13 209.05 261.12 195.19 350.13 360.1 350.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "195.19 350.13 209.05 261.12 0.14 350.13 195.19 350.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "535.41 261.12 600.14 221.47 600.14 105.76 438.77 0.25 535.41 261.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "600.14 105.76 600.14 0.25 438.77 0.25 600.14 105.76"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 379.48,
    y: 304.79,
    width: 168.26,
    height: 0.55,
    transform: "translate(-91.11 288.09) rotate(-31.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 343.41,
    y: -83.26,
    width: 0.55,
    height: 276.38,
    transform: "translate(157.26 348.83) rotate(-66.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "303.39 143.8 286.79 99.4 422.68 115.19 422.62 115.74 287.61 100.05 303.9 143.6 303.39 143.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "358.27 349.36 208 261.09 11.95 345.39 11.73 344.89 208.04 260.48 208.16 260.55 358.55 348.89 358.27 349.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "124.31 211.51 0 138.26 0.28 137.78 124.59 211.03 124.31 211.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 0.14,
    y: 0.19,
    width: 600,
    height: 350
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M198.24,285.32a6.62,6.62,0,0,1-3.21-.73L70.71,212.81a2.36,2.36,0,0,1-1.35-2,3.17,3.17,0,0,1,1.86-2.54L151,162.2a8.15,8.15,0,0,1,7.34-.29l124.32,71.78a2.35,2.35,0,0,1,1.35,2,3.19,3.19,0,0,1-1.86,2.54l-79.79,46.06A8.49,8.49,0,0,1,198.24,285.32Zm-2.94-1.19a7.59,7.59,0,0,0,6.8-.29l79.79-46.07a2.69,2.69,0,0,0,1.6-2.08,1.84,1.84,0,0,0-1.09-1.54L158.08,162.37a7.59,7.59,0,0,0-6.8.29L71.49,208.73a2.67,2.67,0,0,0-1.6,2.08A1.86,1.86,0,0,0,71,212.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M198.24,273.81a6.52,6.52,0,0,1-3.22-.74L70.7,201.29a2.38,2.38,0,0,1-1.37-2,3.21,3.21,0,0,1,1.88-2.56L151,150.65a8.17,8.17,0,0,1,7.36-.3l124.32,71.78a2.4,2.4,0,0,1,1.37,2,3.21,3.21,0,0,1-1.88,2.56l-79.79,46.07A8.53,8.53,0,0,1,198.24,273.81Zm-43.1-123.63a8,8,0,0,0-3.85,1L71.5,197.21a2.68,2.68,0,0,0-1.59,2.06A1.85,1.85,0,0,0,71,200.8l124.32,71.77a7.54,7.54,0,0,0,6.78-.29l79.79-46.07a2.65,2.65,0,0,0,1.59-2.06,1.83,1.83,0,0,0-1.08-1.52L158.07,150.85A6,6,0,0,0,155.14,150.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M315.56,108.41,191.73,36.91a3.22,3.22,0,0,0-2.53-.36h0l-2.29.8.8.19A4.09,4.09,0,0,0,187,39l-28,90.92a5.5,5.5,0,0,0,2.27,6.12l123.84,71.5a3.71,3.71,0,0,0,.91.37l-.31.67,2.19-.77h0a3.49,3.49,0,0,0,2-2.31l28-90.93A5.46,5.46,0,0,0,315.56,108.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M280.61,210.89l.05.05L158.34,140.33a7.8,7.8,0,0,0-7,.29l-79,45.62-2.64-1,.74,3.69h0a2.16,2.16,0,0,0,1.18,1.48L195,261.68a7.8,7.8,0,0,0,7-.29l79.22-45.74a3.19,3.19,0,0,0,1.68-2h0l.75-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M195.17,258.43,70.85,186.65c-1.82-1-1.59-2.87.5-4.08l79.79-46.07a7.87,7.87,0,0,1,7.07-.29L282.53,208c1.82,1,1.59,2.87-.5,4.08l-79.79,46.07A7.87,7.87,0,0,1,195.17,258.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M70.85,184.56l124.32,71.78a7.84,7.84,0,0,0,7.07-.29L282,210a4,4,0,0,0,1.36-1.23c.76,1,.29,2.37-1.36,3.32l-79.79,46.07a7.87,7.87,0,0,1-7.07.29L70.85,186.65a1.88,1.88,0,0,1-.86-2.84A2.69,2.69,0,0,0,70.85,184.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M282.94,208.23,159.1,136.74a5.5,5.5,0,0,1-2.27-6.12l28-90.92a3.18,3.18,0,0,1,4.78-2.05l123.83,71.5a5.46,5.46,0,0,1,2.27,6.11l-28,90.93A3.18,3.18,0,0,1,282.94,208.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M284.64,209a3.62,3.62,0,0,1-1.84-.52L159,137a5.79,5.79,0,0,1-2.39-6.43l28-90.92a3.72,3.72,0,0,1,2.15-2.49,3.4,3.4,0,0,1,3,.29l123.83,71.5a5.75,5.75,0,0,1,2.39,6.42l-28,90.93a3.75,3.75,0,0,1-2.16,2.49A3.15,3.15,0,0,1,284.64,209ZM187.92,37.44a2.7,2.7,0,0,0-1,.18,3.22,3.22,0,0,0-1.85,2.16l-28,90.92a5.2,5.2,0,0,0,2.15,5.81L283.07,208a2.88,2.88,0,0,0,2.55.26,3.19,3.19,0,0,0,1.84-2.15l28-90.92a5.23,5.23,0,0,0-2.15-5.82L189.49,37.88A3.19,3.19,0,0,0,187.92,37.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M132.86,173.49l-4.12-2.37c-.33-.19-.28-.53.1-.75l4.85-2.8a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.09.75l-4.86,2.8A1.42,1.42,0,0,1,132.86,173.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M139.21,177.16l-4.12-2.38c-.33-.19-.28-.52.1-.74l4.85-2.8a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.86,2.8A1.42,1.42,0,0,1,139.21,177.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M145.55,180.82l-4.11-2.37c-.33-.19-.29-.52.1-.74l4.85-2.81a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.2.29.53-.09.75l-4.86,2.8A1.44,1.44,0,0,1,145.55,180.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M154.34,177.8l-4.12-2.38c-.33-.19-.28-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.42,1.42,0,0,1,154.34,177.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M160.69,181.46l-4.12-2.37c-.33-.19-.28-.53.1-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75L162,181.41A1.42,1.42,0,0,1,160.69,181.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M167,185.13l-4.11-2.38c-.33-.19-.29-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.44,1.44,0,0,1,167,185.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M173.38,188.79l-4.11-2.37c-.33-.19-.29-.52.1-.74l4.07-2.36a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.09.75l-4.08,2.35A1.44,1.44,0,0,1,173.38,188.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M179.73,192.46l-4.11-2.37c-.33-.2-.29-.53.09-.75l4.08-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.09.74L181,192.41A1.44,1.44,0,0,1,179.73,192.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M186.08,196.12,182,193.75c-.33-.19-.29-.52.09-.74l4.08-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.1.74l-4.07,2.35A1.41,1.41,0,0,1,186.08,196.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M192.43,199.79l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.08-2.35a1.42,1.42,0,0,1,1.28,0l4.12,2.37c.33.19.28.53-.1.75l-4.07,2.35A1.44,1.44,0,0,1,192.43,199.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M198.78,203.46l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.08-2.35a1.42,1.42,0,0,1,1.28-.06l4.12,2.38c.33.19.28.52-.1.74l-4.07,2.35A1.44,1.44,0,0,1,198.78,203.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M205.13,207.12,201,204.75c-.33-.19-.29-.52.09-.75l4.08-2.35a1.42,1.42,0,0,1,1.28-.05l4.11,2.37c.34.19.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,205.13,207.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M211.48,210.79l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.07-2.35a1.41,1.41,0,0,1,1.29,0l4.11,2.37c.33.19.29.52-.09.74l-4.07,2.35A1.44,1.44,0,0,1,211.48,210.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M163.69,176.06l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.08-2.35a1.42,1.42,0,0,1,1.28-.05l4.12,2.37c.33.19.28.52-.1.75L165,176A1.44,1.44,0,0,1,163.69,176.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M157.25,172.34,153.14,170c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.09.74l-4.07,2.36A1.44,1.44,0,0,1,157.25,172.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M150.79,168.61l-8.85-5.11c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l8.86,5.11c.33.19.29.53-.1.75l-4.07,2.35A1.44,1.44,0,0,1,150.79,168.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M155.3,164.08l-7.18-4.15c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l7.19,4.15c.33.19.29.53-.09.75L156.59,164A1.44,1.44,0,0,1,155.3,164.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M170,179.73l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.08-2.35a1.42,1.42,0,0,1,1.28-.06l4.11,2.38c.33.19.29.52-.09.74l-4.07,2.35A1.44,1.44,0,0,1,170,179.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M176.39,183.39,172.28,181c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,176.39,183.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M182.74,187.06l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74L184,187A1.44,1.44,0,0,1,182.74,187.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M189.09,190.72,185,188.35c-.33-.19-.29-.52.09-.74l4.07-2.36a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.2.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,189.09,190.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M195.44,194.39,191.33,192c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.52-.09.74l-4.07,2.36A1.44,1.44,0,0,1,195.44,194.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M201.79,198.06l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74L203.08,198A1.44,1.44,0,0,1,201.79,198.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M208.14,201.72,204,199.35c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75l-4.08,2.35A1.42,1.42,0,0,1,208.14,201.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M214.49,205.39,210.37,203c-.33-.19-.28-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.42,1.42,0,0,1,214.49,205.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M220.84,209.05l-4.12-2.37c-.33-.19-.28-.52.1-.74l4.07-2.36a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75L222.12,209A1.42,1.42,0,0,1,220.84,209.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M232.12,215.57l-9-5.18c-.33-.19-.29-.52.09-.74l4.08-2.36a1.44,1.44,0,0,1,1.29,0l9,5.18c.33.19.29.52-.1.74l-4.07,2.36A1.44,1.44,0,0,1,232.12,215.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M244.48,208.43l-7.57-4.37c-.33-.19-.29-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l7.57,4.37c.33.19.29.53-.09.75l-4.08,2.35A1.44,1.44,0,0,1,244.48,208.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M181.16,179l-4.11-2.37c-.33-.2-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.52-.09.74L182.45,179A1.44,1.44,0,0,1,181.16,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M174.65,175.25l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.08-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.1.75l-4.07,2.35A1.44,1.44,0,0,1,174.65,175.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M168.15,171.49,164,169.12c-.33-.19-.28-.52.1-.74L168.2,166a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.39,1.39,0,0,1,168.15,171.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M161.64,167.74l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.07-2.35a1.41,1.41,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.09.74l-4.07,2.35A1.44,1.44,0,0,1,161.64,167.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M187.51,182.67l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.07,2.35A1.41,1.41,0,0,1,187.51,182.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M193.86,186.34,189.75,184c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,193.86,186.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M200.21,190l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74L201.5,190A1.44,1.44,0,0,1,200.21,190Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M206.56,193.67l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.07-2.35a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,206.56,193.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M212.91,197.34,208.8,195c-.34-.19-.29-.52.09-.74l4.07-2.35a1.41,1.41,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.09.74l-4.08,2.35A1.42,1.42,0,0,1,212.91,197.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M219.26,201l-4.12-2.37c-.33-.19-.28-.52.1-.74l4.07-2.36a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.2.29.53-.09.75L220.54,201A1.42,1.42,0,0,1,219.26,201Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M225.61,204.67l-4.12-2.37c-.33-.19-.29-.53.1-.75l4.07-2.35a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.52-.09.74l-4.08,2.36A1.42,1.42,0,0,1,225.61,204.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M232,208.34,227.84,206c-.33-.19-.29-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.44,1.44,0,0,1,232,208.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M238.3,212l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.08-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75L239.59,212A1.44,1.44,0,0,1,238.3,212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M177.82,169.94l-4.12-2.37c-.33-.19-.28-.53.1-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75l-4.08,2.35A1.42,1.42,0,0,1,177.82,169.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M171.5,166.29l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.07-2.36a1.44,1.44,0,0,1,1.29,0l4.11,2.38c.33.19.29.52-.09.74l-4.07,2.35A1.44,1.44,0,0,1,171.5,166.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M165.18,162.65l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.08-2.35a1.42,1.42,0,0,1,1.28-.06l4.12,2.38c.33.19.28.52-.1.74l-4.07,2.35A1.44,1.44,0,0,1,165.18,162.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M158.86,159l-4.11-2.37c-.33-.2-.29-.53.09-.75l4.08-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.1.74L160.15,159A1.44,1.44,0,0,1,158.86,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M165.36,155.25l-4.11-2.38c-.33-.19-.29-.52.09-.74l1.35-.78a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.1.75l-1.34.77A1.41,1.41,0,0,1,165.36,155.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M173.6,160l-4.11-2.38c-.33-.19-.29-.52.1-.74l1.34-.78a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75l-1.35.77A1.41,1.41,0,0,1,173.6,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M179.9,163.64l-4.12-2.37c-.33-.19-.28-.53.1-.75l1.34-.77a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-1.35.78A1.42,1.42,0,0,1,179.9,163.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M186.19,167.27l-4.11-2.37c-.33-.19-.29-.52.09-.74l1.34-.78a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-1.34.78A1.44,1.44,0,0,1,186.19,167.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M192.48,170.91l-4.11-2.38c-.33-.19-.29-.52.09-.74l1.35-.78a1.42,1.42,0,0,1,1.28,0l4.12,2.37c.33.19.28.52-.1.74l-1.34.78A1.44,1.44,0,0,1,192.48,170.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M227.6,191.18l-4.11-2.37c-.33-.19-.29-.52.09-.74l1.35-.78a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.52-.09.74l-1.35.78A1.41,1.41,0,0,1,227.6,191.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M233.89,194.82l-4.11-2.38c-.33-.19-.29-.52.1-.74l1.34-.78a1.44,1.44,0,0,1,1.29,0l4.11,2.37c.33.19.29.53-.09.75l-1.35.77A1.44,1.44,0,0,1,233.89,194.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M240.19,198.45l-4.12-2.37c-.33-.2-.28-.53.1-.75l1.34-.78a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.2.29.53-.09.75l-1.35.78A1.42,1.42,0,0,1,240.19,198.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M246.48,202.08l-4.11-2.37c-.33-.19-.29-.53.09-.75l1.34-.77a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-1.35.78A1.42,1.42,0,0,1,246.48,202.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M184.17,173.61l-4.12-2.38c-.33-.19-.28-.52.1-.74l4.07-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.42,1.42,0,0,1,184.17,173.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M190.52,177.27l-4.12-2.37c-.33-.19-.29-.52.1-.74l4.07-2.36a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.2.29.53-.09.75l-4.08,2.35A1.42,1.42,0,0,1,190.52,177.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M196.86,180.94l-4.11-2.37c-.33-.2-.29-.53.1-.75l4.07-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.52-.09.74l-4.08,2.36A1.44,1.44,0,0,1,196.86,180.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M203.21,184.6l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.08-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.09.74l-4.08,2.35A1.41,1.41,0,0,1,203.21,184.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M209.56,188.27l-4.11-2.37c-.33-.19-.29-.53.09-.75l4.08-2.35a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.1.75l-4.07,2.35A1.44,1.44,0,0,1,209.56,188.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M215.91,191.94l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.08-2.35a1.44,1.44,0,0,1,1.29-.06l4.11,2.38c.33.19.29.52-.1.74l-4.07,2.35A1.44,1.44,0,0,1,215.91,191.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M222.26,195.6l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.08-2.36a1.42,1.42,0,0,1,1.28,0l4.12,2.37c.33.19.28.53-.1.75l-4.07,2.35A1.44,1.44,0,0,1,222.26,195.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M228.61,199.27l-4.11-2.38c-.33-.19-.29-.52.09-.74l4.08-2.35a1.39,1.39,0,0,1,1.28-.05l4.12,2.37c.33.19.28.52-.1.74l-4.07,2.35A1.44,1.44,0,0,1,228.61,199.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M235,202.93l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.08-2.36a1.42,1.42,0,0,1,1.28-.05l4.11,2.37c.33.2.29.53-.09.75l-4.07,2.35A1.44,1.44,0,0,1,235,202.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M147.87,174.06l-12.11-7c-.33-.19-.29-.52.09-.74l4.07-2.36a1.44,1.44,0,0,1,1.29-.05l12.11,7c.33.19.29.52-.09.74L149.15,174A1.42,1.42,0,0,1,147.87,174.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M225.87,219.1l-12.11-7c-.33-.19-.29-.52.09-.74l4.08-2.35a1.39,1.39,0,0,1,1.28,0l12.11,7c.33.19.29.52-.09.74L227.16,219A1.44,1.44,0,0,1,225.87,219.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M200.48,212.53l-4.11-2.37c-.33-.19-.29-.52.09-.74l4.85-2.81a1.44,1.44,0,0,1,1.29-.05l4.11,2.37c.33.19.29.53-.09.75l-4.86,2.8A1.42,1.42,0,0,1,200.48,212.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M154.37,185.91l-6.58-3.79c-.33-.2-.29-.53.09-.75l4.86-2.8a1.44,1.44,0,0,1,1.29,0l6.57,3.79c.33.19.29.53-.09.75l-4.85,2.8A1.44,1.44,0,0,1,154.37,185.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M194.36,209l-6.58-3.8c-.33-.19-.28-.52.1-.74l4.85-2.8a1.41,1.41,0,0,1,1.29,0l6.57,3.79c.33.19.29.53-.09.75l-4.85,2.8A1.44,1.44,0,0,1,194.36,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M163.53,191.2,157,187.4c-.33-.19-.29-.52.1-.74l4.85-2.8a1.41,1.41,0,0,1,1.29-.05l6.57,3.79c.33.19.29.53-.09.75l-4.85,2.8A1.44,1.44,0,0,1,163.53,191.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M163.23,183.83l28.59,16.51c.35.2.35.53,0,.74l-4.95,2.86a1.44,1.44,0,0,1-1.28,0L157,187.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M218.22,219.18l4.58,2.64c.27.16.24.43-.07.61l-2,1.15a1.15,1.15,0,0,1-1.05,0L215.11,221c-.28-.16-.24-.43.07-.61l2-1.15A1.15,1.15,0,0,1,218.22,219.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M211.82,215.48l4.58,2.65c.27.15.24.43-.08.61l-2,1.14a1.21,1.21,0,0,1-1.06.05l-4.58-2.65c-.27-.15-.23-.43.08-.61l2-1.14A1.21,1.21,0,0,1,211.82,215.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M205.47,211.82l4.58,2.64c.27.16.24.43-.08.61l-2,1.15a1.17,1.17,0,0,1-1.06,0l-4.58-2.64c-.27-.16-.23-.43.08-.61l2-1.15A1.15,1.15,0,0,1,205.47,211.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M215.33,213.46l4.58,2.64c.27.16.23.43-.08.61l-2,1.15a1.17,1.17,0,0,1-1.06,0l-4.58-2.64c-.27-.16-.24-.43.08-.61l2-1.15A1.17,1.17,0,0,1,215.33,213.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M163.85,226a5.89,5.89,0,0,1-2.92-.69L129,206.89a2.23,2.23,0,0,1-1.27-1.9,3,3,0,0,1,1.72-2.38l16.43-9.48a7.25,7.25,0,0,1,6.63-.26l31.91,18.43a2.23,2.23,0,0,1,1.27,1.9,2.93,2.93,0,0,1-1.72,2.37l-16.42,9.49A7.67,7.67,0,0,1,163.85,226Zm-14.23-33a6.9,6.9,0,0,0-3.34.84l-16.42,9.48a2.25,2.25,0,0,0-1.34,1.71,1.52,1.52,0,0,0,.89,1.23l31.91,18.42a6.51,6.51,0,0,0,5.86-.25l16.42-9.49c.85-.49,1.34-1.11,1.34-1.7a1.5,1.5,0,0,0-.89-1.23l-31.91-18.43A5.1,5.1,0,0,0,149.62,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M202.49,72.35l-3.63-2.09a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.82-.34L202.9,71a1,1,0,0,1,.4,1h0A.54.54,0,0,1,202.49,72.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M211.11,77.33l-5.34-3.08a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.82-.34L211.53,76a1,1,0,0,1,.4,1h0A.54.54,0,0,1,211.11,77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M195.18,88.48l-3.62-2.09a.94.94,0,0,1-.4-1h0A.53.53,0,0,1,192,85l3.62,2.1a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,195.18,88.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M202.87,92.92l-5.34-3.09a.93.93,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l5.34,3.09a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,202.87,92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M191.63,69.47l-2.26-1.3a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l2.27,1.3a1,1,0,0,1,.4,1h0A.53.53,0,0,1,191.63,69.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M198.44,76.8l-6.91-4a.94.94,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l6.92,4a1,1,0,0,1,.4,1h0A.54.54,0,0,1,198.44,76.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M192.07,79.9l-2.27-1.31a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.82-.34l2.26,1.31a.94.94,0,0,1,.4,1h0A.54.54,0,0,1,192.07,79.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M203.71,100.18l-6.05-3.49a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l6.05,3.49a1,1,0,0,1,.4,1h0A.54.54,0,0,1,203.71,100.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M189.53,85.21l-1.45-.83a.94.94,0,0,1-.4-1h0a.53.53,0,0,1,.81-.33l1.45.83a1,1,0,0,1,.41,1h0A.54.54,0,0,1,189.53,85.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M188.16,91.2l-1.81-1a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l1.81,1a1,1,0,0,1,.4,1h0A.53.53,0,0,1,188.16,91.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M195.17,95.25l-4.75-2.74a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l4.76,2.74a1,1,0,0,1,.4,1h0A.54.54,0,0,1,195.17,95.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M188.91,95l-3.42-2a.93.93,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l3.42,2a.93.93,0,0,1,.4,1h0A.54.54,0,0,1,188.91,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M208.89,103.19l-2.19-1.27a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l2.19,1.27a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,208.89,103.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M200.48,84.76l-6-3.49a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l6.05,3.49a1,1,0,0,1,.4,1h0A.54.54,0,0,1,200.48,84.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M201.2,81.78,190.67,75.7a1,1,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l10.53,6.08a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,201.2,81.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M195,85l-6.05-3.49a.93.93,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l6.05,3.49a1,1,0,0,1,.4,1h0A.53.53,0,0,1,195,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M205.07,87.4l-2.2-1.26a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.81-.33l2.2,1.26a.93.93,0,0,1,.4,1h0A.53.53,0,0,1,205.07,87.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M222.14,83.67l-7.74-4.44a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l7.74,4.44a1,1,0,0,1,.41,1h0A.54.54,0,0,1,222.14,83.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M194.48,91.46l-7.26-4.19a1,1,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l7.26,4.19a1,1,0,0,1,.41,1h0A.54.54,0,0,1,194.48,91.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M195.58,68.36l-5.35-3.08a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.82-.34L196,67a1,1,0,0,1,.4,1h0A.54.54,0,0,1,195.58,68.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M187.79,97.77l-6.18-3.57a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l6.18,3.57a1,1,0,0,1,.41,1h0A.54.54,0,0,1,187.79,97.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M193,104.4l-3.62-2.09a.94.94,0,0,1-.4-1h0a.53.53,0,0,1,.81-.33l3.62,2.09a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,193,104.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M201.64,109.38l-5.34-3.08a.94.94,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l5.34,3.09a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,201.64,109.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M185.71,120.53l-3.63-2.1a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.82-.34l3.62,2.09a1,1,0,0,1,.4,1h0A.54.54,0,0,1,185.71,120.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M193.4,125l-5.34-3.09a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l5.34,3.09a.93.93,0,0,1,.4,1h0A.54.54,0,0,1,193.4,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M182.16,101.52l-2.26-1.3a.93.93,0,0,1-.4-1h0a.52.52,0,0,1,.81-.34l2.26,1.3a1,1,0,0,1,.41,1h0A.54.54,0,0,1,182.16,101.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M189,108.85l-6.91-4a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l6.91,4a.93.93,0,0,1,.4,1h0A.53.53,0,0,1,189,108.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M182.59,112l-2.26-1.31a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l2.27,1.31a1,1,0,0,1,.4,1h0A.54.54,0,0,1,182.59,112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M194.23,132.23l-6-3.49a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l6,3.49a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,194.23,132.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M180.06,117.26l-1.46-.84a1,1,0,0,1-.4-1h0A.54.54,0,0,1,179,115l1.45.84a.94.94,0,0,1,.4,1h0A.53.53,0,0,1,180.06,117.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M178.68,123.25l-1.8-1a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l1.8,1a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,178.68,123.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M185.7,127.3l-4.76-2.74a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.82-.34l4.75,2.74a.93.93,0,0,1,.4,1h0A.52.52,0,0,1,185.7,127.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M179.44,127.08l-3.42-2a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l3.42,2a1,1,0,0,1,.4,1h0A.54.54,0,0,1,179.44,127.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M199.42,135.24l-2.2-1.27a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l2.2,1.27a.93.93,0,0,1,.4,1h0A.54.54,0,0,1,199.42,135.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M191,116.81l-6-3.49a1,1,0,0,1-.41-1h0a.54.54,0,0,1,.82-.33l6,3.49a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,191,116.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M191.73,113.83l-10.54-6.08a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.82-.33l10.53,6.08a.93.93,0,0,1,.4,1h0A.54.54,0,0,1,191.73,113.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M185.51,117l-6-3.49a.94.94,0,0,1-.41-1h0a.54.54,0,0,1,.82-.34l6,3.49a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,185.51,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M195.6,119.45l-2.2-1.27a.93.93,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l2.2,1.27a1,1,0,0,1,.4,1h0A.53.53,0,0,1,195.6,119.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M185,123.51l-7.27-4.19a1,1,0,0,1-.4-1h0a.53.53,0,0,1,.81-.34l7.27,4.19a.94.94,0,0,1,.4,1h0A.53.53,0,0,1,185,123.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M186.1,100.41l-5.34-3.09a.94.94,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34L186.51,99a.94.94,0,0,1,.41,1h0A.54.54,0,0,1,186.1,100.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M178.32,129.82l-6.19-3.57a1,1,0,0,1-.4-1h0a.54.54,0,0,1,.81-.34l6.19,3.57a.93.93,0,0,1,.4,1h0A.53.53,0,0,1,178.32,129.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M277,186.3a4.56,4.56,0,0,1-2.26-.64l-58.12-33.55a7,7,0,0,1-3-7.75L230,90.86a4.43,4.43,0,0,1,2.55-2.94,4.2,4.2,0,0,1,3.69.37l58.11,33.55a7,7,0,0,1,3,7.74l-16.33,53.51a4.41,4.41,0,0,1-2.55,2.94A3.81,3.81,0,0,1,277,186.3Zm-43-98.12a3.48,3.48,0,0,0-1.23.23,3.9,3.9,0,0,0-2.23,2.6l-16.33,53.51a6.42,6.42,0,0,0,2.72,7.13L275,185.2a3.67,3.67,0,0,0,3.23.34,3.89,3.89,0,0,0,2.23-2.61l16.33-53.5A6.42,6.42,0,0,0,294,122.3L235.92,88.75A4,4,0,0,0,233.92,88.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M286,140.35a3.21,3.21,0,0,1-1.6-.45l-50.83-29.35a4.91,4.91,0,0,1-2.08-5.43l2.08-6.81a3.16,3.16,0,0,1,1.8-2.08,3,3,0,0,1,2.61.26l50.84,29.35a4.89,4.89,0,0,1,2.07,5.43l-2.08,6.81a3.11,3.11,0,0,1-1.8,2.08A2.87,2.87,0,0,1,286,140.35ZM236.36,96.57a2.05,2.05,0,0,0-.81.16,2.59,2.59,0,0,0-1.49,1.74L232,105.28a4.35,4.35,0,0,0,1.83,4.81l50.84,29.35a2.44,2.44,0,0,0,2.15.22,2.59,2.59,0,0,0,1.49-1.74l2.08-6.81a4.35,4.35,0,0,0-1.84-4.81L237.7,97A2.7,2.7,0,0,0,236.36,96.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M278.88,158.15l-9.53-5.5a4.63,4.63,0,0,1-2-5.12l2.08-6.81a2.65,2.65,0,0,1,4-1.67l9.53,5.5a4.61,4.61,0,0,1,2,5.12l-2.08,6.81A2.65,2.65,0,0,1,278.88,158.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M274.7,177.31a3.21,3.21,0,0,1-1.6-.45l-9.53-5.5a4.89,4.89,0,0,1-2.07-5.43l2.08-6.81a3.11,3.11,0,0,1,1.8-2.08,3,3,0,0,1,2.61.26l9.53,5.5a4.89,4.89,0,0,1,2.07,5.43L277.51,175a3.11,3.11,0,0,1-1.8,2.08A2.67,2.67,0,0,1,274.7,177.31Zm-8.31-19.93a2.1,2.1,0,0,0-.82.16,2.59,2.59,0,0,0-1.49,1.73L262,166.09a4.33,4.33,0,0,0,1.83,4.81l9.53,5.5a2.44,2.44,0,0,0,2.15.22,2.55,2.55,0,0,0,1.48-1.73l2.08-6.82a4.33,4.33,0,0,0-1.83-4.81l-9.53-5.5A2.67,2.67,0,0,0,266.39,157.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M252.45,165.17a3.19,3.19,0,0,1-1.59-.46L222.09,148.1a4.9,4.9,0,0,1-2.08-5.42l7.9-25.89a3.16,3.16,0,0,1,1.8-2.08,3,3,0,0,1,2.61.26l28.77,16.62a4.89,4.89,0,0,1,2.08,5.42l-7.9,25.89a3.1,3.1,0,0,1-1.81,2.07A2.67,2.67,0,0,1,252.45,165.17Zm-21.73-50.12a2.25,2.25,0,0,0-.81.16,2.59,2.59,0,0,0-1.49,1.74l-7.9,25.89a4.34,4.34,0,0,0,1.83,4.81l28.77,16.61a2.44,2.44,0,0,0,2.15.22,2.61,2.61,0,0,0,1.49-1.74l7.9-25.89a4.33,4.33,0,0,0-1.83-4.81l-28.77-16.61A2.7,2.7,0,0,0,230.72,115.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "233.55 134.17 230.67 132.5 227.06 144.33 229.94 145.99 233.55 134.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "239.08 140.25 236.2 138.59 233.34 147.95 236.23 149.61 239.08 140.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "247.28 137.61 244.39 135.95 239.63 151.57 242.51 153.23 247.28 137.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "255.44 135.07 252.56 133.41 245.91 155.19 248.79 156.85 255.44 135.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M292.26,110.73a1.91,1.91,0,0,1-.94-.26,2,2,0,0,1-.94-2.49,1.53,1.53,0,0,1,.92-.84,1.81,1.81,0,0,1,1.46.18,2.05,2.05,0,0,1,.94,2.49,1.56,1.56,0,0,1-.92.84A1.82,1.82,0,0,1,292.26,110.73Zm-.44-3.14a1.34,1.34,0,0,0-.35,0,1,1,0,0,0-.6.55,1.49,1.49,0,0,0,.71,1.82,1.27,1.27,0,0,0,1,.13,1,1,0,0,0,.6-.55,1.5,1.5,0,0,0-.71-1.81A1.35,1.35,0,0,0,291.82,107.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M296.46,113.13a1.94,1.94,0,0,1-.95-.26,2,2,0,0,1-.93-2.49,1.45,1.45,0,0,1,.92-.84,1.81,1.81,0,0,1,1.46.17,2,2,0,0,1,.93,2.5h0a1.53,1.53,0,0,1-.92.84A1.75,1.75,0,0,1,296.46,113.13ZM296,110a1.06,1.06,0,0,0-.35.05,1,1,0,0,0-.6.55,1.51,1.51,0,0,0,.72,1.82,1.24,1.24,0,0,0,1,.13,1,1,0,0,0,.61-.55,1.51,1.51,0,0,0-.72-1.82A1.38,1.38,0,0,0,296,110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M301.84,114.5a1.37,1.37,0,0,1-2,.54,1.77,1.77,0,0,1-.82-2.16,1.37,1.37,0,0,1,2-.54A1.77,1.77,0,0,1,301.84,114.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.46,
    y: 261.69,
    width: 0.54,
    height: 10.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 115.46,
    y: 274.72,
    width: 0.54,
    height: 3.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 295.97,
    y: 41.12,
    width: 0.54,
    height: 10.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 295.97,
    y: 54.09,
    width: 0.54,
    height: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 295.97,
    y: 59.63,
    width: 0.54,
    height: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 317.78,
    y: 201.17,
    width: 0.54,
    height: 10.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 317.78,
    y: 214.14,
    width: 0.54,
    height: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 317.78,
    y: 219.68,
    width: 0.54,
    height: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 317.78,
    y: 225.22,
    width: 0.54,
    height: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 49.46,
    y: 178.77,
    width: 0.54,
    height: 3.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 49.46,
    y: 151.91,
    width: 0.54,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.46,
    y: 118.96,
    width: 0.54,
    height: 3.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 115.46,
    y: 105.93,
    width: 0.54,
    height: 10.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.46,
    y: 92.1,
    width: 0.54,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.46,
    y: 76.21,
    width: 0.54,
    height: 10.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M409.86,200.78a8.36,8.36,0,0,1-4.12-.95l-48.8-28.14a3,3,0,0,1-1.72-2.53c0-1.17.87-2.35,2.38-3.22l33.31-19.23c2.78-1.61,7-1.78,9.43-.38l48.8,28.14a3,3,0,0,1,1.72,2.53c0,1.17-.86,2.35-2.37,3.22l-33.31,19.23A10.91,10.91,0,0,1,409.86,200.78ZM396.23,145.9a10.36,10.36,0,0,0-5.06,1.27L357.86,166.4c-1.34.77-2.11,1.78-2.11,2.76a2.48,2.48,0,0,0,1.46,2.07L406,199.37c2.27,1.31,6.26,1.14,8.9-.38l33.31-19.23c1.34-.77,2.11-1.78,2.11-2.76a2.47,2.47,0,0,0-1.45-2.07l-48.8-28.14A7.91,7.91,0,0,0,396.23,145.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M405.88,190.75l-48.81-28.14c-2.35-1.36-2.05-3.73.66-5.29L391,138.08c2.72-1.56,6.82-1.73,9.17-.38L449,165.84c2.35,1.36,2.06,3.73-.66,5.3L415,190.37C412.33,191.93,408.23,192.1,405.88,190.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M409.86,192a8.49,8.49,0,0,1-4.13-.95l-48.8-28.14a3,3,0,0,1-1.73-2.55c0-1.18.87-2.37,2.39-3.24l33.31-19.23c2.79-1.61,7-1.79,9.45-.38l48.81,28.13a3,3,0,0,1,1.73,2.55c0,1.19-.87,2.37-2.39,3.25l-33.31,19.23A11,11,0,0,1,409.86,192Zm-13.63-54.88a10.38,10.38,0,0,0-5,1.26l-33.32,19.24c-1.33.77-2.1,1.77-2.1,2.74a2.48,2.48,0,0,0,1.45,2.05L406,190.5c2.27,1.31,6.25,1.14,8.88-.38l33.31-19.23c1.33-.77,2.1-1.77,2.1-2.75a2.48,2.48,0,0,0-1.44-2L400.07,138A7.87,7.87,0,0,0,396.23,137.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M444.82,51.69,398.07,24.74a2.71,2.71,0,0,0-2.8-.21h0L358,46.08l13.72,25V93.91c0,3.14,1.91,6.78,4.26,8.14l13.39,7.73L410.73,180l36.78-21.22.05,0,.13-.08h0a3.86,3.86,0,0,0,1.39-3.39V59.83C449.08,56.69,447.17,53.05,444.82,51.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M407.7,179.89,361,152.94c-2.35-1.36-4.26-5-4.26-8.14V49.39c0-3.14,1.91-4.58,4.26-3.22l46.75,27c2.35,1.36,4.26,5,4.26,8.14v95.41C412,179.81,410.05,181.25,407.7,179.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M361,46.17l46.75,27a7.92,7.92,0,0,1,2.62,2.73l37.1-21.48a7.87,7.87,0,0,0-2.6-2.68L398.07,24.74a2.71,2.71,0,0,0-2.8-.21h0L358.33,45.86A2.82,2.82,0,0,1,361,46.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M358,46.06l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M410.56,74.41a8.15,8.15,0,0,0-2.86-2.6L361,44.86a4,4,0,0,0-.47-.23l-2.15,1.23a2.82,2.82,0,0,1,2.62.31l46.75,27a7.92,7.92,0,0,1,2.62,2.73l37.1-21.48c-.21-.33-.43-.63-.66-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M358,44.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M406.56,95.94a1.62,1.62,0,0,1-.78-.23l-43.29-25a4,4,0,0,1-1.69-3.2V55.68a1.69,1.69,0,0,1,.71-1.54,1.32,1.32,0,0,1,1.36.08l43.28,25a4,4,0,0,1,1.69,3.2V94.25a1.69,1.69,0,0,1-.7,1.54A1.17,1.17,0,0,1,406.56,95.94Zm-.41-.88a.64.64,0,0,0,.61.08,1,1,0,0,0,.34-.89V82.41a3.26,3.26,0,0,0-1.32-2.55l-43.29-25a.61.61,0,0,0-.61-.08,1,1,0,0,0-.33.89V67.52a3.23,3.23,0,0,0,1.32,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M387.35,73.5,381.29,70a1.29,1.29,0,0,1-.53-1h0c0-.4.24-.58.53-.41l6.06,3.5a1.27,1.27,0,0,1,.54,1h0C387.89,73.49,387.65,73.67,387.35,73.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M406.56,119.68a1.62,1.62,0,0,1-.78-.23l-43.29-25a3.94,3.94,0,0,1-1.69-3.19V79.42a1.69,1.69,0,0,1,.71-1.54,1.32,1.32,0,0,1,1.36.08l43.28,25a4,4,0,0,1,1.69,3.2V118a1.68,1.68,0,0,1-.7,1.54A1.08,1.08,0,0,1,406.56,119.68Zm-.41-.88a.64.64,0,0,0,.61.08,1,1,0,0,0,.34-.9V106.15a3.26,3.26,0,0,0-1.32-2.55l-43.29-25a.66.66,0,0,0-.61-.08,1,1,0,0,0-.33.9V91.26a3.24,3.24,0,0,0,1.32,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M387.35,97.24l-6.06-3.5a1.28,1.28,0,0,1-.53-1h0c0-.39.24-.57.53-.4l6.06,3.5a1.26,1.26,0,0,1,.54,1h0C387.89,97.23,387.65,97.41,387.35,97.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M406,142.86l-43.29-25a3.61,3.61,0,0,1-1.5-2.88V103.15c0-1.1.67-1.61,1.5-1.13L406,127a3.61,3.61,0,0,1,1.5,2.87v11.84C407.47,142.83,406.8,143.34,406,142.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M406.56,167.15a1.51,1.51,0,0,1-.78-.23l-43.29-25a4,4,0,0,1-1.69-3.2V126.89a1.69,1.69,0,0,1,.71-1.54,1.34,1.34,0,0,1,1.36.08l43.28,25a4,4,0,0,1,1.69,3.2v11.84a1.69,1.69,0,0,1-.7,1.54A1.17,1.17,0,0,1,406.56,167.15Zm-.41-.88a.64.64,0,0,0,.61.08,1,1,0,0,0,.34-.89V153.62a3.26,3.26,0,0,0-1.32-2.55l-43.29-25a.63.63,0,0,0-.61-.08,1,1,0,0,0-.33.89v11.84a3.23,3.23,0,0,0,1.32,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M387.35,144.72l-6.06-3.5a1.29,1.29,0,0,1-.53-1h0c0-.39.24-.58.53-.4l6.06,3.49a1.27,1.27,0,0,1,.54,1h0C387.89,144.71,387.65,144.89,387.35,144.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M371.14,130.32l-6.06-3.5a1.29,1.29,0,0,1-.53-1h0c0-.4.24-.58.53-.41l6.06,3.5a1.27,1.27,0,0,1,.54,1h0C371.68,130.31,371.44,130.49,371.14,130.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "374.55 108.87 345.45 125.67 345.45 114.21 364.62 103.14 374.55 108.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "362.69 104.25 371.33 109.25 373.27 108.13 364.62 103.14 362.69 104.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M389.2,143.75l17.28-16.32a2.22,2.22,0,0,0-.86-.62l-30.25-17.46-19,9.46,10.44,13.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "375.57 109.46 346.26 126.38 346.26 114.92 365.64 103.73 375.57 109.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M407.47,129.88a3.86,3.86,0,0,0-1-2.45l-20.15,11.68v11.47l21.14-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M404.44,128.61l3,1.75v-.48a3.86,3.86,0,0,0-1-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M407.47,129.88a3.67,3.67,0,0,0-.39-1.56l-19.85,11.51V151.3l20.24-11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M389.76,136.35l-43.29-25a1,1,0,0,0-1-.06h0l-1.32.77.83.08c0,.11,0,.23,0,.36v11.84a3.58,3.58,0,0,0,1.5,2.87l43,24.81v1l1.31-.77h0a1.31,1.31,0,0,0,.53-1.21V139.22A3.59,3.59,0,0,0,389.76,136.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M388.43,153l-43.29-25a3.61,3.61,0,0,1-1.5-2.88V113.27c0-1.1.67-1.61,1.5-1.13l43.29,25a3.59,3.59,0,0,1,1.5,2.87v11.84C389.93,153,389.26,153.46,388.43,153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M369.82,131.1l-6.06-3.5a1.27,1.27,0,0,1-.54-1h0c0-.39.24-.57.54-.4l6.06,3.49a1.29,1.29,0,0,1,.53,1h0C370.35,131.09,370.11,131.27,369.82,131.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M363.71,104.84v11.47l31.23,17.81,11.54-6.69a2.73,2.73,0,0,0-.86-.62l-40-23.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "385.09 123.23 369.63 114.31 369.63 102.45 385.09 111.37 385.09 123.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "383.97 123.88 368.51 114.95 368.51 103.09 383.97 112.02 383.97 123.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "382.86 124.52 367.4 115.6 367.4 103.74 382.86 112.67 382.86 124.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "381.74 125.17 366.28 116.24 366.28 104.39 381.74 113.31 381.74 125.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "380.62 125.81 365.17 116.89 365.17 105.03 380.62 113.96 380.62 125.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "379.51 126.46 364.05 117.53 364.05 105.68 379.51 114.6 379.51 126.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "378.39 127.1 362.94 118.18 362.94 106.32 378.39 115.25 378.39 127.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "377.28 127.75 361.82 118.82 361.82 106.97 377.28 115.89 377.28 127.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "376.16 128.39 360.7 119.47 360.7 107.61 376.16 116.54 376.16 128.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "375.05 129.04 359.59 120.11 359.59 108.26 375.05 117.18 375.05 129.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "373.93 129.69 358.47 120.76 358.47 108.9 373.93 117.83 373.93 129.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "372.81 130.33 357.36 121.41 357.36 109.55 372.81 118.47 372.81 130.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "371.7 130.98 356.24 122.05 356.24 110.19 371.7 119.12 371.7 130.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "406.63 131.5 391.17 122.58 391.17 110.72 406.63 119.64 406.63 131.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "405.51 132.15 390.05 123.22 390.05 111.36 405.51 120.29 405.51 132.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "404.44 132.28 388.98 123.35 388.98 111.5 404.44 120.42 404.44 132.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "403.32 132.92 387.86 124 387.86 112.14 403.32 121.07 403.32 132.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "402.23 133.16 386.77 124.24 386.77 112.38 402.23 121.31 402.23 133.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "401.12 133.81 385.66 124.88 385.66 113.03 401.12 121.95 401.12 133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "400 134.45 384.54 125.53 384.54 113.67 400 122.6 400 134.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "398.89 135.1 383.43 126.17 383.43 114.32 398.89 123.24 398.89 135.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "397.77 135.74 382.31 126.82 382.31 114.96 397.77 123.89 397.77 135.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "396.65 136.39 381.2 127.46 381.2 115.61 396.65 124.53 396.65 136.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "395.54 137.03 380.08 128.11 380.08 116.25 395.54 125.18 395.54 137.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "394.42 137.68 378.97 128.75 378.97 116.9 394.42 125.82 394.42 137.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "393.31 138.32 377.85 129.4 377.85 117.54 393.31 126.47 393.31 138.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "392.19 138.97 376.74 130.05 376.74 118.19 392.19 127.11 392.19 138.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "391.08 139.62 375.62 130.69 375.62 118.83 391.08 127.76 391.08 139.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "389.96 140.26 374.5 131.34 374.5 119.48 389.96 128.4 389.96 140.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "388.85 140.91 373.39 131.98 373.39 120.13 388.85 129.05 388.85 140.91"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "423.95 76.83 423.04 77.36 423.04 76.31 423.95 75.79 423.95 76.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "425.85 75.74 424.94 76.26 424.94 75.21 425.85 74.69 425.85 75.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "427.75 74.64 426.84 75.17 426.84 74.12 427.75 73.59 427.75 74.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "425.81 77.97 424.9 78.49 424.9 77.44 425.81 76.92 425.81 77.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "427.75 76.83 426.84 77.36 426.84 76.31 427.75 75.79 427.75 76.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "433.85 71.12 432.94 71.64 432.94 70.6 433.85 70.07 433.85 71.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "433.85 89.42 432.94 89.95 432.94 88.9 433.85 88.37 433.85 89.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "433.85 91.39 432.94 91.91 432.94 90.86 433.85 90.34 433.85 91.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "433.85 100.86 432.94 101.39 432.94 100.34 433.85 99.81 433.85 100.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "439.08 68.1 438.17 68.62 438.17 67.57 439.08 67.05 439.08 68.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "429.65 73.54 428.74 74.07 428.74 73.02 429.65 72.49 429.65 73.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 333.8,
    y: 189.47,
    width: 51.43,
    height: 0.57,
    transform: "translate(-46.72 204.92) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M318.49,192l-.28-.5,14.23-8.22a12.2,12.2,0,0,1,5.06-1.45l15.28-1.2a11.55,11.55,0,0,0,4.82-1.38L371.84,171l.28.5-14.23,8.22a12.21,12.21,0,0,1-5.07,1.45l-15.27,1.2a11.9,11.9,0,0,0-4.83,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M356.29,213.77l-.29-.5,14.24-8.21a4.54,4.54,0,0,0,2.31-2.68l2.08-8.82a5.09,5.09,0,0,1,2.59-3l14.23-8.21.29.5L377.51,191a4.52,4.52,0,0,0-2.32,2.68l-2.08,8.82a5,5,0,0,1-2.59,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M346.84,208.31l-.29-.49,15.17-8.76a5.74,5.74,0,0,0,1.69-1.41l6.11-7.86a6.34,6.34,0,0,1,1.86-1.56l15.17-8.75.28.5-15.16,8.75a5.63,5.63,0,0,0-1.69,1.42L363.87,198a6.32,6.32,0,0,1-1.86,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M327.94,197.4l-.29-.49,15.17-8.76a11,11,0,0,1,2.65-1.06l13.6-3.52a10.12,10.12,0,0,0,2.5-1l15.17-8.76.29.5-15.17,8.76a10.62,10.62,0,0,1-2.64,1.05l-13.61,3.53a9.74,9.74,0,0,0-2.5,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 475.31,
    cy: 76.92,
    r: 75.67,
    transform: "translate(84.83 358.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 357.97,
    cy: 76.92,
    r: 75.67,
    transform: "translate(50.46 275.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M524.87,200.78a8.32,8.32,0,0,1-4.11-.95L472,171.69a3,3,0,0,1-1.72-2.53c0-1.17.86-2.35,2.37-3.22l33.31-19.23c2.79-1.61,7-1.78,9.44-.38l48.8,28.14a3,3,0,0,1,1.72,2.53c0,1.17-.87,2.35-2.38,3.22l-33.31,19.23A10.91,10.91,0,0,1,524.87,200.78ZM511.24,145.9a10.32,10.32,0,0,0-5.05,1.27L472.88,166.4c-1.34.77-2.11,1.78-2.11,2.76a2.47,2.47,0,0,0,1.45,2.07L521,199.37c2.28,1.32,6.27,1.14,8.9-.38l33.32-19.23c1.34-.78,2.11-1.78,2.11-2.76a2.48,2.48,0,0,0-1.46-2.07l-48.8-28.14A7.88,7.88,0,0,0,511.24,145.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M520.89,190.75l-48.8-28.14c-2.35-1.36-2.06-3.73.66-5.29l33.31-19.24c2.71-1.56,6.81-1.73,9.16-.38L564,165.84c2.35,1.36,2.05,3.73-.66,5.3l-33.31,19.23C527.34,191.93,523.24,192.1,520.89,190.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M524.87,192a8.47,8.47,0,0,1-4.12-.95l-48.81-28.14a3,3,0,0,1-1.73-2.55c0-1.18.87-2.37,2.39-3.24l33.31-19.23c2.79-1.61,7-1.79,9.46-.38l48.8,28.13a3,3,0,0,1,1.73,2.55c0,1.19-.87,2.37-2.39,3.25L530.2,190.62A10.92,10.92,0,0,1,524.87,192Zm-13.63-54.88a10.38,10.38,0,0,0-5,1.26l-33.31,19.24c-1.34.77-2.1,1.77-2.1,2.74a2.46,2.46,0,0,0,1.44,2.05L521,190.5c2.27,1.31,6.26,1.14,8.88-.38l33.31-19.23c1.34-.77,2.11-1.77,2.11-2.75a2.49,2.49,0,0,0-1.45-2L515.08,138A7.84,7.84,0,0,0,511.24,137.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M559,52.47,512.65,25.73a2.7,2.7,0,0,0-2.78-.2h0l-37,21.39,13.61,24.75v22.7c0,3.11,1.89,6.73,4.23,8.08L504,110.1l21.23,69.62,36.5-21.05,0,0,.13-.08h0a3.84,3.84,0,0,0,1.38-3.36V60.55C563.26,57.44,561.36,53.82,559,52.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M522.2,179.67l-46.38-26.74c-2.33-1.35-4.22-5-4.22-8.08V50.19c0-3.11,1.89-4.54,4.22-3.19L522.2,73.74c2.34,1.34,4.23,5,4.23,8.07v94.66C526.43,179.58,524.54,181,522.2,179.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M475.82,47,522.2,73.74a7.74,7.74,0,0,1,2.61,2.71l36.8-21.31A7.88,7.88,0,0,0,559,52.47L512.65,25.73a2.7,2.7,0,0,0-2.78-.2h0L473.23,46.69A2.77,2.77,0,0,1,475.82,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M472.88,46.89l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M525,75a8,8,0,0,0-2.84-2.58L475.82,45.7a3.39,3.39,0,0,0-.47-.23l-2.12,1.22a2.77,2.77,0,0,1,2.59.31L522.2,73.74a7.74,7.74,0,0,1,2.61,2.71l36.8-21.31a11,11,0,0,0-.66-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M472.88,45.59l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M521.08,96.37a1.49,1.49,0,0,1-.78-.23L477.35,71.35a3.92,3.92,0,0,1-1.67-3.17V56.43a1.68,1.68,0,0,1,.7-1.53,1.33,1.33,0,0,1,1.34.08l42.95,24.8A3.92,3.92,0,0,1,522.35,83V94.69a1.68,1.68,0,0,1-.7,1.53A1.16,1.16,0,0,1,521.08,96.37ZM477,55.49a.36.36,0,0,0-.2.06,1,1,0,0,0-.33.88V68.18a3.24,3.24,0,0,0,1.3,2.53L520.67,95.5a.63.63,0,0,0,.61.08,1,1,0,0,0,.33-.89V83a3.22,3.22,0,0,0-1.31-2.53l-42.95-24.8A.9.9,0,0,0,477,55.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M502,74.11l-6-3.47a1.23,1.23,0,0,1-.53-1h0c0-.39.23-.57.53-.4l6,3.47a1.27,1.27,0,0,1,.53,1h0C502.55,74.1,502.31,74.28,502,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M521.08,119.92a1.49,1.49,0,0,1-.78-.23L477.35,94.9a3.92,3.92,0,0,1-1.67-3.17V80a1.68,1.68,0,0,1,.7-1.53,1.33,1.33,0,0,1,1.34.08l42.95,24.8a3.92,3.92,0,0,1,1.68,3.17v11.75a1.67,1.67,0,0,1-.7,1.52A1.16,1.16,0,0,1,521.08,119.92Zm-.41-.87a.63.63,0,0,0,.61.08,1,1,0,0,0,.33-.88V106.5A3.22,3.22,0,0,0,520.3,104l-42.95-24.8a.62.62,0,0,0-.6-.07,1,1,0,0,0-.33.88V91.73a3.24,3.24,0,0,0,1.3,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M502,97.67l-6-3.47a1.27,1.27,0,0,1-.53-1h0c0-.39.23-.57.53-.4l6,3.47a1.27,1.27,0,0,1,.53,1h0C502.55,97.66,502.31,97.83,502,97.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M521.08,143.73a1.59,1.59,0,0,1-.78-.23l-42.95-24.8a3.92,3.92,0,0,1-1.67-3.17V103.78a1.68,1.68,0,0,1,.7-1.53,1.33,1.33,0,0,1,1.34.08l42.95,24.8a3.92,3.92,0,0,1,1.68,3.17v11.75a1.67,1.67,0,0,1-.7,1.52A1.07,1.07,0,0,1,521.08,143.73ZM477,102.85a.35.35,0,0,0-.2.05,1,1,0,0,0-.33.88v11.75a3.24,3.24,0,0,0,1.3,2.53l42.95,24.79a.63.63,0,0,0,.61.08,1,1,0,0,0,.33-.88V130.3a3.22,3.22,0,0,0-1.31-2.53L477.35,103A.79.79,0,0,0,477,102.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M502,121.47,496,118a1.27,1.27,0,0,1-.53-1h0c0-.39.23-.57.53-.4l6,3.47a1.29,1.29,0,0,1,.53,1h0C502.55,121.46,502.31,121.64,502,121.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M521.08,167a1.59,1.59,0,0,1-.78-.23L477.35,142a3.91,3.91,0,0,1-1.67-3.17V127.08a1.68,1.68,0,0,1,.7-1.53,1.33,1.33,0,0,1,1.34.08l42.95,24.8a3.92,3.92,0,0,1,1.68,3.17v11.75a1.7,1.7,0,0,1-.7,1.53A1.16,1.16,0,0,1,521.08,167ZM477,126.15a.35.35,0,0,0-.2,0,1,1,0,0,0-.33.88v11.75a3.24,3.24,0,0,0,1.3,2.53l42.95,24.79a.63.63,0,0,0,.61.08,1,1,0,0,0,.33-.88V153.6a3.22,3.22,0,0,0-1.31-2.53l-42.95-24.79A.79.79,0,0,0,477,126.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M502,144.77l-6-3.47a1.27,1.27,0,0,1-.53-1h0c0-.39.23-.57.53-.4l6,3.47a1.29,1.29,0,0,1,.53,1h0C502.55,144.76,502.31,144.94,502,144.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M533.76,167.08a1.35,1.35,0,0,1-.71-.19,2.25,2.25,0,0,1-.92-2V83.61a5.71,5.71,0,0,1,2.39-4.53l21.23-12.26a1.7,1.7,0,0,1,1.74-.11,2.25,2.25,0,0,1,.92,2.05V150a5.71,5.71,0,0,1-2.39,4.54l-21.23,12.25A2,2,0,0,1,533.76,167.08Zm23-100a1.49,1.49,0,0,0-.76.24L534.79,79.55a5.11,5.11,0,0,0-2.11,4.06v81.23a1.74,1.74,0,0,0,.64,1.58,1.16,1.16,0,0,0,1.2-.12l21.23-12.25a5.11,5.11,0,0,0,2.11-4.07V68.76a1.74,1.74,0,0,0-.64-1.58A.83.83,0,0,0,556.78,67.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 442.36,
    y: 181.04,
    width: 45.5,
    height: 0.57,
    transform: "translate(-28.39 256.57) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 450.3,
    y: 185.62,
    width: 45.5,
    height: 0.57,
    transform: "translate(-29.62 261.15) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 458.24,
    y: 190.21,
    width: 45.5,
    height: 0.57,
    transform: "translate(-30.86 265.64) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "469.37 206.71 469.08 206.21 508.48 183.44 508.76 183.94 469.37 206.71"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 452.3,
    cy: 250.37,
    r: 72.36,
    transform: "matrix(0.22, -0.97, 0.97, 0.22, 107.44, 635.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M440.67,321.67a11.87,11.87,0,0,1-5.82-1.39l-39.4-22.75c-1.61-.93-2.5-2.18-2.5-3.53a4.28,4.28,0,0,1,2.5-3.53L463.89,251a12.86,12.86,0,0,1,11.65,0l39.4,22.75a4.25,4.25,0,0,1,2.5,3.52c0,1.35-.89,2.6-2.5,3.53l-68.45,39.52A11.84,11.84,0,0,1,440.67,321.67Zm29-71.54a11.33,11.33,0,0,0-5.53,1.32L395.73,291a3.18,3.18,0,0,0,0,6.06l39.41,22.75a12.26,12.26,0,0,0,11.07,0l68.44-39.52a3.71,3.71,0,0,0,2.21-3c0-1.13-.78-2.2-2.21-3l-39.4-22.75A11.35,11.35,0,0,0,469.71,250.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M517.34,264.8h0V245.9l-23.88,3.19-17.87-10.32a12.56,12.56,0,0,0-11.36,0l-32,18.49-38.77,5.17v19.24h0a4,4,0,0,0,2.33,3.17l39.41,22.75a12.54,12.54,0,0,0,11.35,0L515,268.07a4,4,0,0,0,2.33-3.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M515,242.48l-39.4-22.75a12.56,12.56,0,0,0-11.36,0l-68.45,39.52c-3.13,1.81-3.13,4.75,0,6.56l39.41,22.75a12.54,12.54,0,0,0,11.35,0L515,249C518.13,247.23,518.13,244.3,515,242.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M515,247.9l-68.45,39.51a12.54,12.54,0,0,1-11.35,0l-39.41-22.75a4.35,4.35,0,0,1-2.28-2.7c-.3,1.37.46,2.8,2.28,3.85l39.41,22.75a12.54,12.54,0,0,0,11.35,0L515,249c1.82-1,2.58-2.48,2.28-3.85A4.33,4.33,0,0,1,515,247.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "469.63 283.03 467.77 284.11 467.77 281.96 469.63 280.88 469.63 283.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "473.54 280.78 471.67 281.86 471.67 279.7 473.54 278.63 473.54 280.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "477.44 278.53 475.57 279.6 475.57 277.45 477.44 276.37 477.44 278.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "474.25 284.73 472.38 285.81 472.38 283.66 474.25 282.58 474.25 284.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "477.69 282.75 475.82 283.83 475.82 281.67 477.69 280.6 477.69 282.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "489.96 271.3 488.09 272.38 488.09 270.22 489.96 269.14 489.96 271.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "500.71 265.09 498.84 266.17 498.84 264.01 500.71 262.94 500.71 265.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "481.34 276.27 479.48 277.35 479.48 275.2 481.34 274.12 481.34 276.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "454.87 237.36 482.71 253.4 480.14 254.88 452.31 238.85 454.87 237.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "453.27 239.4 455.02 238.39 481.89 253.87 482.71 253.4 454.87 237.36 452.31 238.85 453.27 239.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "462.67 232.85 490.51 248.88 487.94 250.37 460.1 234.33 462.67 232.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "461.07 234.89 462.82 233.88 489.69 249.36 490.51 248.88 462.67 232.85 460.1 234.33 461.07 234.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "470.47 228.34 498.31 244.37 495.75 245.86 467.9 229.82 470.47 228.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "468.87 230.38 470.62 229.36 497.49 244.84 498.31 244.37 470.47 228.33 467.9 229.82 468.87 230.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M440.36,279.66a4,4,0,0,1-2-.46l-26.51-15.31a1.51,1.51,0,0,1-.87-1.3,2,2,0,0,1,1.17-1.62l25.9-15a5,5,0,0,1,4.5-.18l26.51,15.31a1.53,1.53,0,0,1,.87,1.3,2,2,0,0,1-1.17,1.62l-25.91,15A5.19,5.19,0,0,1,440.36,279.66Zm-1.69-1a4.39,4.39,0,0,0,3.92-.17l25.91-15c.56-.33.89-.74.89-1.13a1,1,0,0,0-.59-.8l-26.51-15.31a4.36,4.36,0,0,0-3.92.17l-25.91,15c-.56.33-.88.74-.88,1.13a1,1,0,0,0,.58.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M428.1,295.52l-21.88-12.63a2.29,2.29,0,0,1-.94-1.81v-1.63c0-.69.42-1,.94-.71l21.88,12.63a2.27,2.27,0,0,1,.95,1.81v1.62C429.05,295.5,428.62,295.82,428.1,295.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M540,86.39l11.43-6.6a1.17,1.17,0,0,0,.49-.94V78c0-.36-.22-.53-.49-.37L540,84.23a1.16,1.16,0,0,0-.5.94V86C539.47,86.38,539.69,86.55,540,86.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M540,96.52l11.43-6.6a1.19,1.19,0,0,0,.49-1v-.84c0-.37-.22-.54-.49-.38L540,94.35a1.17,1.17,0,0,0-.5,1v.84C539.47,96.51,539.69,96.67,540,96.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M540,106.64,551.4,100a1.17,1.17,0,0,0,.49-.94v-.85c0-.36-.22-.53-.49-.37L540,104.48a1.16,1.16,0,0,0-.5.94v.85C539.47,106.63,539.69,106.8,540,106.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M540,116.77l11.43-6.6a1.19,1.19,0,0,0,.49-1v-.84c0-.37-.22-.54-.49-.38L540,114.6a1.17,1.17,0,0,0-.5,1v.84C539.47,116.76,539.69,116.92,540,116.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M540,126.89l11.43-6.6a1.17,1.17,0,0,0,.49-.94v-.85c0-.36-.22-.53-.49-.37L540,124.73a1.16,1.16,0,0,0-.5.94v.85C539.47,126.88,539.69,127.05,540,126.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M540,137l11.43-6.6a1.19,1.19,0,0,0,.49-.95v-.84c0-.37-.22-.54-.49-.38L540,134.85a1.17,1.17,0,0,0-.5,1v.84C539.47,137,539.69,137.17,540,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M540,147.14l11.43-6.6a1.17,1.17,0,0,0,.49-.94v-.85c0-.36-.22-.53-.49-.37L540,145a1.16,1.16,0,0,0-.5.94v.85C539.47,147.13,539.69,147.3,540,147.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M540,157.27l11.43-6.6a1.19,1.19,0,0,0,.49-.95v-.84c0-.37-.22-.54-.49-.38L540,155.1a1.17,1.17,0,0,0-.5,1v.84C539.47,157.26,539.69,157.42,540,157.27Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsm);
export default __webpack_public_path__ + "static/media/csm.1ff80625d54df35c3670c48f67195671.svg";
export { ForwardRef as ReactComponent };